module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/background.8c58778.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/background.jpg
// module id = Sa06
// module chunks = 1